import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GuestSiteSessionDataQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GuestSiteSessionDataQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    activeSession: {
      __typename?: 'EventSession';
      id: string;
      hasUnlocked: boolean;
      hasIdentity: boolean;
      eventCTA: {
        __typename?: 'EventSessionCTA';
        id: string;
        rsvpIsEnabled: boolean;
        scheduleHasInviteOnlyItems: boolean;
        hasSpecificGuestsPages: boolean;
        requiresPassword: boolean;
        label: string;
        rsvpIsCompleted: boolean;
        rsvpAttendanceStatus: Types.EventRSVPAttendanceStatus;
      };
      person?: { __typename?: 'Person'; id: string; fullName?: string | null; firstName?: string | null; avatarName?: string | null; email?: string | null } | null;
    };
  } | null;
};

export const GuestSiteSessionDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GuestSiteSessionData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeSession' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'GetEventCTASession' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GetEventCTASession' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventSession' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasUnlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasIdentity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventCTA' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpIsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleHasInviteOnlyItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasSpecificGuestsPages' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresPassword' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpIsCompleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsvpAttendanceStatus' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'person' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGuestSiteSessionDataQuery__
 *
 * To run a query within a React component, call `useGuestSiteSessionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestSiteSessionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestSiteSessionDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGuestSiteSessionDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestSiteSessionDataQuery, GuestSiteSessionDataQueryVariables>) {
  return ApolloReactHooks.useQuery<GuestSiteSessionDataQuery, GuestSiteSessionDataQueryVariables>(GuestSiteSessionDataDocument, baseOptions);
}
export function useGuestSiteSessionDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestSiteSessionDataQuery, GuestSiteSessionDataQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GuestSiteSessionDataQuery, GuestSiteSessionDataQueryVariables>(GuestSiteSessionDataDocument, baseOptions);
}
export type GuestSiteSessionDataQueryHookResult = ReturnType<typeof useGuestSiteSessionDataQuery>;
export type GuestSiteSessionDataLazyQueryHookResult = ReturnType<typeof useGuestSiteSessionDataLazyQuery>;
export type GuestSiteSessionDataQueryResult = Apollo.QueryResult<GuestSiteSessionDataQuery, GuestSiteSessionDataQueryVariables>;
